import axios from 'axios';
import { useState, useEffect } from 'react';
import { EmployeeFeedback } from '../models/FeedbackInterfaces';

export const useGetUserFeedbacks = () => {
  const [feedbacks, setFeedbacks] = useState<EmployeeFeedback[]>([]);
  const [loadingFeedbacks, setLoadingFeedbacks] = useState(false);

  const getUserFeedbacks = async () => {
    setLoadingFeedbacks(true);
    try {
      const response = await axios.get('api/feedback/my');

      setFeedbacks(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingFeedbacks(false);
    }
  };

  useEffect(() => {
    getUserFeedbacks();
  }, []);

  return { feedbacks, loadingFeedbacks, getUserFeedbacks };
};
